import API from "../../../api/index";
import { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import "../../../style/myStyle.css"; // Importa il tuo file CSS
import Header from "../../../components/Header";
import { colors } from "../../../theme";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import CloseIcon from "@mui/icons-material/Close";
import CircularIndeterminate from "../../../components/circularProgress";

const InternalDetection = ({ customerName }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [internalDetection, setInternalDetection] = useState([]);
  const [charged, setCharged] = useState(false)
  const [option, setOption] = useState({
    chart: {
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
    },
  });

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    // Rimuovi l'ascoltatore di eventi quando il componente viene smontato
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [series, setSeries] = useState([
    {
      name: "Count",
      data: [],
    },
  ]);
  const [selectedIp, setSelectedIp] = useState(null);

  if (!customerName && window.sessionStorage.getItem("type") === "reseller") {
    window.sessionStorage.setItem("selectedTab", "Dashboard");
    setTimeout(function checkCondition() {
      if (window.sessionStorage.getItem("selectedTab") === "Dashboard") {
        window.location.href = `/${window.sessionStorage.getItem("type")}/home`;
      } else {
        setTimeout(checkCondition, 500); // Aspetta 1 secondo e poi richiama la funzione
      }
    }, 0);
  }

  useEffect(() => {
    API.getInternalDetection()
      .then((result) => {
        const transformedData = result.data.map((item) => ({
          id: item.ip,
          ...item,
        }));
        setCharged(true);
        setInternalDetection(transformedData);
      })
      .catch((error) => {
        console.error(
          "[InternalDetection] Si è verificato un errore durante il recupero dei dati:",
          error.message,
          error.stack
        );
        setCharged(true);
      });
  }, []);

  const handleSelect = (ip) => {
    setSelectedIp(ip);
    setOpenDialog(true);
    API.getInternalDetectionDetail({ip: ip})
      .then((response) => {

        // Estrarre i dati necessari dalla risposta
        const chartData = response.data.map((item) => ({
          count: item.count,
          dettaglio: item.dettaglio,
        }));

        // Creare un oggetto options per ApexCharts
        const options = {
          chart: {
            type: "bar",           
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },

          colors: ["#4CCEAC"],
          xaxis: {
            categories: chartData.map((item) => item.dettaglio),
          },
        };

        // Creare un array di oggetti series per ApexCharts
        const series = [
          {
            name: "Count", // Puoi personalizzare il nome della serie
            data: chartData.map((item) => item.count),
          },
        ];

        // Imposta le opzioni del grafico
        setOption(options);

        // Imposta i dati della serie del grafico
        setSeries(series);
      })
      .catch((error) => {
        console.error(
          "[handleSelect] Errore durante il recupero dei dettagli interni di ra:",
          error
        );
      });
  };

  const columns = [
    {
      field: "ip",
      headerName: "Source Ip",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "select",
      headerName: "Select",
      headerAlign: "center",
      flex: 1,
      renderCell: (cellValues) => (
        <button
          className="selectButton"
          onClick={() => handleSelect(cellValues.row.ip)}
        >
          Select
        </button>
      ),
    },
  ];
  const minHeight = 100; // Altezza minima desiderata
  const maxHeight = 10000; // Altezza massima desiderata
  return (
    <Box m="20px">
      <Header
        title="Internal Detection"
        subtitle=""
        desc="LOGs for each IP are grouped here, offering instant overviews on those generating the most LOGs."
      />
      <Box
      className='internalDet'
        display="flex"
        m="40px 0 0  0"
        height="73vh"
        gap={6}
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: "#459296",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#459296",
            borderBottom: "none",
            borderRadius: 0,
          },
          "& .MuiDataGrid-toolbarContainer": {
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            gap: 4,
            backgroundColor: "#459296",
            color: "#459296",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: "#459296",
          },
          "& .MuiCheckbox-root": {
            color: "#459296 !important",
          },
          "& .css-1ny7bi9-MuiButtonBase-root-MuiButton-root": {
            color: "white",
          },
        }}
      >
        {internalDetection.length === 0 ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
          >
            <CircularIndeterminate charged={charged} />
          </Box>
        ) : (
          <DataGrid
            rows={internalDetection}
            columns={columns}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                printOptions: { disableToolbarButton: true },
              },
            }}
          />
        )}
        {selectedIp &&
          (windowSize.width > 1024 ? (
            <Card
              sx={{
                background: "#2A354A",
                width: "50%", // Imposta la larghezza al 100% della finestra
                height: "73vh", // Imposta l'altezza al 50% della finestra, adattabile alle tue esigenze
                overflow: "auto", // Per abilitare lo scrolling se necessario
              }}
            >
              <div style={{ overflow: "auto", maxHeight: "100%" }}>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <h2 style={{ marginLeft: "25px" }}>
                    Chart for IP: {selectedIp}
                  </h2>
                  <button
                    className="closeButton"
                    onClick={() => setSelectedIp(null)}
                  >
                    <CloseIcon />
                  </button>
                </div>

                <ReactApexChart
                  id="chartGlobal"
                  options={option}
                  series={series}
                  height={Math.min(
                    maxHeight,
                    Math.max(minHeight, series[0].data.length * 100)
                  )}
                  type="bar"
                  width={"95%"}
                />
              </div>
            </Card>
          ) : (
            <Dialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              fullWidth
              maxWidth="xs"
              //fullScreen del dialog ,se non piace levalo
              fullScreen={windowSize.width <= 1024} 
            >
              <DialogTitle>Chart for IP: {selectedIp}</DialogTitle>
              <DialogContent>
                <Card
                  sx={{
                    background: "#2A354A",
                    width: "100%", // Imposta la larghezza al 100% della finestra
                    height: "73vh", // Imposta l'altezza al 50% della finestra, adattabile alle tue esigenze
                    overflow: "auto", // Per abilitare lo scrolling se necessario
                  }}
                >
                  <div style={{ overflow: "auto", maxHeight: "100%", alignItems: "center", }}>
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <h2 style={{ marginLeft: "25px" }}>
                        Chart for IP: {selectedIp}
                      </h2>
                      <button
                        className="closeButton"
                        onClick={() => setSelectedIp(null)}
                      >
                        <CloseIcon />
                      </button>
                    </div>

                    <ReactApexChart
                      id="chartGlobal"
                      options={option}
                      series={series}
                      height={Math.min(
                        maxHeight,
                        Math.max(minHeight, series[0].data.length * 100)
                      )}
                      type="bar"
                      width={"95%"}
                    />
                  </div>
                </Card>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                    setSelectedIp(null);
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ))}
      </Box>
    </Box>
  );
};
export default InternalDetection;
